import { useAuth0 } from '@auth0/auth0-react';
import SoftBox from "components/SoftComponents/SoftBox";
import { useSoftUIController } from 'hooks/context';
import PropTypes from "prop-types";

const LogoutButton = ({ children }) => {
	const { logout, isAuthenticated } = useAuth0();

	return (
		isAuthenticated && (
			<SoftBox onClick={() => {
				sessionStorage.setItem('logoutRequested', 'true');
				logout(
					{ logoutParams: { returnTo: window.location.origin } }
				);
			}
			}>
				{children}
			</SoftBox>
		)
	)
}

// Typechecking props of the LogoutButton
LogoutButton.propTypes = {
	children: PropTypes.node.isRequired,
};


export default LogoutButton